<template>
  <div
    class="ag-cell-label-container"
    :class="{ 'date-field': isDate }"
    role="presentation"
    @click="onClick"
    data-testid="grid-header-drilldown"
  >
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
      {{ params.displayName }}
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClick() {
      this.params.column.userProvidedColDef.click?.();
    },
  },
  computed: {
    isDate() {
      return this.params.column.userProvidedColDef.isDate;
    },
  },
};
</script>

<style scoped>
.date-field .ag-header-cell-label {
  text-decoration: underline;
}

.date-field.ag-cell-label-container {
  cursor: pointer;
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
